import { render, staticRenderFns } from "./KdmArctic.vue?vue&type=template&id=ca55c772&lang=pug"
import script from "./KdmArctic.vue?vue&type=script&lang=js"
export * from "./KdmArctic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports